"use strict";
/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Fragments.
//

exports.CHAR = "\x01-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.RESTRICTED_CHAR = "\x01-\b\x0B\f\x0E-\x1F\x7F-\x84\x86-\x9F";
exports.S = " \t\r\n"; // tslint:disable-next-line:max-line-length

exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040"; //
// Regular expressions.
//

exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.RESTRICTED_CHAR_RE = new RegExp("^[" + exports.RESTRICTED_CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20; //
// Lists.
//

/** All characters in the ``S`` production. */

exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */

function isChar(c) {
  return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}

exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */

function isRestrictedChar(c) {
  return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}

exports.isRestrictedChar = isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */

function isCharAndNotRestricted(c) {
  return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}

exports.isCharAndNotRestricted = isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */

function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}

exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */
// tslint:disable-next-line:cyclomatic-complexity

function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}

exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */

function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}

exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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